"use strict";
/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Fragments.
//

exports.CHAR = "\x01-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.RESTRICTED_CHAR = "\x01-\b\x0B\f\x0E-\x1F\x7F-\x84\x86-\x9F";
exports.S = " \t\r\n"; // tslint:disable-next-line:max-line-length

exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040"; //
// Regular expressions.
//

exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.RESTRICTED_CHAR_RE = new RegExp("^[" + exports.RESTRICTED_CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20; //
// Lists.
//

/** All characters in the ``S`` production. */

exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */

function isChar(c) {
  return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}

exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */

function isRestrictedChar(c) {
  return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}

exports.isRestrictedChar = isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */

function isCharAndNotRestricted(c) {
  return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}

exports.isCharAndNotRestricted = isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */

function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}

exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
// tslint:disable-next-line:cyclomatic-complexity

function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}

exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */

function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}

exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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